import { NavBar } from "@snapchat/snap-design-system";
import { FC, ReactNode } from "react";
import { SideNavItems } from "../side-navigation/SideNavigation";
import { LeftContent } from "./LeftContent";
import { rightContentOverflow } from "./NavigationBar.styles";

interface NavigationBarProps {
    items: SideNavItems[];
    leftContent?: ReactNode;
    centerContent?: ReactNode;
    rightContent?: ReactNode;
}

export const NavigationBar: FC<NavigationBarProps> = ({ items, leftContent, centerContent, rightContent }) => {
    return (
        <NavBar
            className={rightContentOverflow}
            leftContent={leftContent || <LeftContent items={items} />}
            centerContent={centerContent}
            rightContent={rightContent}
        />
    );
};
